import { render, staticRenderFns } from "./ResetTwoFactor.vue?vue&type=template&id=3f3cf9f9&scoped=true"
import script from "./ResetTwoFactor.vue?vue&type=script&lang=js"
export * from "./ResetTwoFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3cf9f9",
  null
  
)

export default component.exports